
export default {
  name: "kui-fieldset",
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    fieldset: function fieldset(opts) {
      if (_.isString(opts)) {
        if ((arguments.length <= 1 ? 0 : arguments.length - 1) > 1) {
          return this[opts].call(this, arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]);
        } else {
          return this[opts].call(this, arguments.length <= 1 ? undefined : arguments[1]);
        }
      } else {
        _.assign(this.options, opts);
      }
    },
    setTitle: function setTitle(title) {
      this.options.title = title;
    }
  }

};


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui/default/fieldset/src/fieldset.js
// module id = 1509
// module chunks = 2